import { WhiskSdkProvider as Provider } from "@paperclip-labs/whisk-sdk";
import { IdentityResolver } from "@paperclip-labs/whisk-sdk/identity";

const WhiskSdkProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider
      apiKey={import.meta.env.VITE_WHISK_API_KEY}
      config={{
        identity: {
          resolverOrder: [
            IdentityResolver.Ens,
            IdentityResolver.Farcaster,
            IdentityResolver.Base,
            IdentityResolver.Nns,
            IdentityResolver.Uni,
            IdentityResolver.Lens,
            IdentityResolver.World,
          ],
        },
      }}
    >
      {children}
    </Provider>
  );
};

export default WhiskSdkProvider;
